import React, { ReactNode } from 'react';
import { styles } from './MiniCard.css';

export interface MiniCardProps {
  title: string;
  image: ReactNode;
  destinationUrl: string;
  highlightText?: string | boolean;
  variant?: 'default' | 'flat';
  size?: 'default' | 'large';
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const MiniCard = ({
  title,
  image,
  destinationUrl,
  variant = 'default',
  size = 'default',
  highlightText = variant === 'default',
  onClick,
}: MiniCardProps) => {
  const highlightedTitle = React.useMemo(() => {
    if (!highlightText) return title;
    if (highlightText === true) return <strong>{title}</strong>;

    const parts = title.split(new RegExp(`(${highlightText})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === highlightText.toLowerCase() ? <strong key={index}>{part}</strong> : part
    );
  }, [title, highlightText]);

  return (
    <a className={styles.container({ variant, size })} href={destinationUrl} onClick={onClick}>
      <div className={styles.image({ size })}>{image}</div>
      <div className={styles.title}>
        <span>{highlightedTitle}</span>
      </div>
    </a>
  );
};
